<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-show="valid ? false : true"
              show
              dismissible
              variant="danger"
            >
              <i class="mdi mdi-block-helper mr-2"></i
              >{{ $t("overview.table.citizen.invalid") }}
            </b-alert>
            <!-- <hr> -->
            <form class="needs-validation" @submit.prevent="searchData()">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="validationCustom01"
                      >{{ $t("form.citizen.label.name") }}
                    </label>
                    <input
                      id="validationCustom01"
                      v-model="form.nama"
                      type="text"
                      class="form-control"
                      :placeholder="$t('form.citizen.placeholder.name')"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="validationCustom02">{{
                      $t("form.citizen.label.nik")
                    }}</label>
                    <input
                      id="validationCustom02"
                      v-model="form.nik"
                      type="text"
                      class="form-control"
                      :placeholder="$t('form.citizen.placeholder.nik')"
                      value="Otto"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="validationCustom02">{{
                      $t("form.citizen.label.nkk")
                    }}</label>
                    <input
                      id="validationCustom02"
                      v-model="form.nkk"
                      type="text"
                      class="form-control"
                      :placeholder="$t('form.citizen.placeholder.nkk')"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="validationCustom03">{{
                      $t("form.citizen.label.address")
                    }}</label>
                    <input
                      id="validationCustom03"
                      v-model="form.alamat"
                      type="text"
                      class="form-control"
                      :placeholder="$t('form.citizen.placeholder.address')"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="validationCustom04">{{
                      $t("form.citizen.label.dob")
                    }}</label>
                    <input
                      id="validationCustom04"
                      v-model="form.tanggal_lahir"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="validationCustom05">{{
                      $t("form.citizen.label.birthplace")
                    }}</label>
                    <input
                      id="validationCustom05"
                      v-model="form.tempat_lahir"
                      type="text"
                      class="form-control"
                      :placeholder="$t('form.citizen.placeholder.birthplace')"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                  <label><b>Birth Year Range</b></label>
                  <div class="row">
                    <div class="col-6">
                      <datepicker
                        :value="form.year_start"
                        :format="'yyyy'"
                        :bootstrap-styling="true"
                        :placeholder="'Start Year'"
                        minimum-view="year"
                        input-class="form-control"
                        @input="yearStart"
                      ></datepicker>
                    </div>
                    <div class="col-6">
                      <datepicker
                        :value="form.year_end"
                        :format="'yyyy'"
                        :bootstrap-styling="true"
                        :placeholder="'End Year'"
                        minimum-view="year"
                        input-class="form-control"
                        @input="yearEnd"
                      ></datepicker>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label
                      ><b>{{ $t("form.citizen.label.search-range") }}</b></label
                    >
                    <vue-slide-bar
                      v-model="search_value"
                      :min="0"
                      :max="1000"
                    />
                    <b-button-group class="mt-1 btn-group-sm">
                      <b-button variant="secondary" @click="search_value -= 1">
                        <i class="fas fa-minus"></i>
                      </b-button>
                      <b-form-input
                        ref="input-size"
                        size="sm"
                        for="text"
                        :value="search_value"
                        maxlength="4"
                        v-model="search_value"
                        style="width: 50px"
                      ></b-form-input>
                      <b-button variant="secondary" @click="search_value += 1">
                        <i class="fas fa-plus"></i>
                      </b-button>
                    </b-button-group>
                  </div>
                  <button
                    class="btn btn-block btn-primary float-right"
                    type="submit"
                  >
                    <b-spinner small v-if="loading" class="mr-2"></b-spinner>
                    <span v-if="loading">{{
                      $t("button.search.loading")
                    }}</span>
                    <i class="fas fa-search mr-2" v-if="!loading"></i>
                    <span v-if="!loading">{{ $t("button.search.label") }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
      <!-- end col -->
    </div>
    <!-- end row -->
    <!-- <Table :isSearch="isSearch" :searchData="searchRes"/> -->
    <div class="row mt-3 mb-4" v-if="tableData[0]">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div
              class="
                card-title
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <h5>
                {{ $t("table.header-label") }}
              </h5>
              <b-button
                class="mx-1 my-1 btn-sm btn-secondary btn"
                @click="showSecretAll"
              >
                <span v-if="!secret.all.value">
                  <i class="fas fa-eye-slash mr-1"></i>
                  Hide Secret
                </span>
                <span v-if="secret.all.value">
                  <i class="fas fa-eye mr-1"></i>
                  Show Secret
                </span>
              </b-button>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.show-label") }}&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;{{ $t("table.entri-label") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.search.label") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('navbar.search.text')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive table-hover mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                show-empty
              >
                <template #empty>
                  <h6 class="text-center">{{ $t("table.empty-text") }}</h6>
                </template>
                <template #cell(nama)="row">
                  <span>
                    <img
                      src="@/assets/images/users/avatar-10.jpg"
                      alt=""
                      class="text-center"
                      width="50px"
                    />
                  </span>
                  <p>{{ row.item.nama }}</p>
                </template>
                <template #cell(tanggal_lahir)="row">
                  <span> {{ row.item.tanggal_lahir }} </span><br />
                  <span class="font-weight-bold">
                    <small> Zodiak : {{ row.item.zodiac }} </small><br />
                    <small class="text-capitalize">
                      Shio : {{ row.item.shio }}
                    </small>
                  </span>
                </template>
                <template #cell(nik)="row">
                  <span v-if="secret.all.value">
                    <span v-if="!showSecret(row.item)">
                      {{ row.item.nik_secret }}
                    </span>
                    <span v-if="showSecret(row.item)">
                      {{ row.item.nik }}
                    </span>
                  </span>
                  <span v-if="!secret.all.value">
                    <span v-if="showSecret(row.item)">
                      {{ row.item.nik_secret }}
                    </span>
                    <span v-if="!showSecret(row.item)">
                      {{ row.item.nik }}
                    </span>
                  </span>
                </template>
                <template #cell(nkk)="row">
                  <span v-if="secret.all.value">
                    <span v-if="!showSecret(row.item)">
                      {{ row.item.nkk_secret }}
                    </span>
                    <span v-if="showSecret(row.item)">
                      {{ row.item.nkk }}
                    </span>
                  </span>
                  <span v-if="!secret.all.value">
                    <span v-if="showSecret(row.item)">
                      {{ row.item.nkk_secret }}
                    </span>
                    <span v-if="!showSecret(row.item)">
                      {{ row.item.nkk }}
                    </span>
                  </span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{ name: 'citizen-view', params: { id: row.item._id } }"
                    ><b-button
                      class="btn-sm"
                      variant="secondary"
                      @click="sendProps()"
                    >
                      <i class="fas fa-info-circle"></i> </b-button
                  ></router-link>

                  <b-button
                    class="mx-1 my-1 px-2 btn-sm btn-secondary btn"
                    @click="openMapsModal(row.item.nik, row.item.alamat)"
                  >
                    <i class="fas fa-map-marker-alt"></i>
                  </b-button>
                  <b-button
                    class="my-1 btn-sm btn-secondary btn"
                    @click="showSecretItem(row.item._id, row.item.nik)"
                  >
                    <i class="fas fa-eye"></i>
                  </b-button>

                  <b-modal
                    size="xl"
                    hide-footer
                    :id="'modal-maps' + row.item.nik"
                    centered
                    :title="'Location'"
                    title-class="font-18"
                  >
                    <div class="row">
                      <div class="col-lg-12">
                        <gmap-map
                          ref="mymap"
                          :center="{ lat: citizen_lat, lng: citizen_long }"
                          :zoom="18"
                          style="height: 80vh"
                        >
                          <gmap-marker
                            :position="
                              google &&
                              new google.maps.LatLng(citizen_lat, citizen_long)
                            "
                          ></gmap-marker>
                        </gmap-map>
                      </div>
                    </div>
                  </b-modal>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rows > 10">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="!tableData[0] && search && error == '' && !loading"
    >
      <div class="col-12">
        <div class="card pt-5 pb-5">
          <div class="card-body p-5">
            <h6 class="text-center text-secondary">{{ $t("all.dnf") }}</h6>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="!tableData[0] && search && error !== '' && !loading"
    >
      <div class="col-12">
        <div class="card pt-5 pb-5">
          <div class="card-body p-5">
            <h6 class="text-center text-secondary">{{ error }}</h6>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Datepicker from "vuejs-datepicker";
import PreferenceService from "@/helpers/preference.service.js";
import appConfig from "@/app.config";
import CitizenService from "@/helpers/citizen.service";
import Maps from "../citizen/maps.vue";
import VueSlideBar from "vue-slide-bar";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import { gmapApi } from "vue2-google-maps";
import EventBus from "@/helpers/eventBus";
import Horoscope from "@/helpers/horoscope";

export default {
  page: {
    title: "Citizen profil",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { VueSlideBar, Layout, PageHeader, Maps, Datepicker },
  data() {
    return {
      test: [],
      search_value: 0,
      error: "",
      search: false,
      title: this.$t("overview.table.citizen.citizen-search"),
      elastic: "",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("overview.table.citizen.citizen-search"),
          active: true,
        },
      ],
      form: {
        nama: "",
        nik: "",
        nkk: "",
        alamat: "",
        tanggal_lahir: "",
        tempat_lahir: "",
        year_start: "",
        year_end: "",
      },
      valid: true,
      submitted: false,
      submitform: false,
      submit: false,
      typesubmit: false,
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      loading: false,
      openMap: false,
      geocoder: null,
      citizen_lat: 0,
      citizen_long: 0,
      fields: [
        {
          key: "no",
          label: "#",
        },
        {
          key: "nama",
          label: this.$t("table.citizen.th.name"),
          sortable: true,
        },
        { key: "nik", label: this.$t("table.citizen.th.nik"), sortable: true },
        { key: "nkk", label: this.$t("table.citizen.th.nkk"), sortable: true },
        {
          key: "tempat_lahir",
          label: this.$t("table.citizen.th.birthplace"),
          sortable: true,
        },
        {
          key: "tanggal_lahir",
          label: this.$t("table.citizen.th.dob"),
          sortable: true,
        },
        { key: "actions", label: this.$t("table.citizen.th.action") },
      ],
      secret: {
        all: {
          value: true,
        },
        item: {
          value: [],
        },
      },
      shioYear: [],
    };
  },

  validations: {
    form: {
      nama: {},
      nik: {},
      nkk: {},
      alamat: {},
      tanggal_lahir: {},
      tempat_lahir: {},
      year_start: {},
      year_end: {},
    },
  },

  computed: {
    google: gmapApi,
    rows() {
      return this.tableData.length;
    },
  },

  methods: {
    yearStart(dt) {
      this.form.year_start = moment(dt).format("YYYY");
    },
    yearEnd(dt) {
      this.form.year_end = moment(dt).format("YYYY");
    },
    showSecretAll() {
      this.secret.all.value
        ? (this.secret.all.value = false)
        : (this.secret.all.value = true);
    },
    showSecretItem(id, nik) {
      const item = { id: id, nik: nik };
      const found = this.secret.item.value.some((el) => el.id == id);
      const index = this.secret.item.value.indexOf(item);
      if (found) {
        this.secret.item.value.splice(index, 1);
      } else {
        this.secret.item.value.push(item);
      }
    },
    showSecret(item) {
      return this.secret.item.value.some((el) => el.id === item._id);
    },
    onSendBackProps() {
      let data = [];
      EventBus.$once("sendBackProps", (val) => {
        this.test = val;
        console.log("back data  => ", val);
      });
    },
    sendProps() {
      const data = {
        nama: this.form.nama,
        nik: this.form.nik,
        nkk: this.form.nkk,
        alamat: this.form.alamat,
        tanggal_lahir: this.form.tanggal_lahir,
        tempat_lahir: this.form.tempat_lahir,
      };
      EventBus.$emit("sendProps", data);
      console.log("send prop => ", data);
    },
    getPreferences() {
      this.shioYear = Horoscope.getShioYear();
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          // console.log(response.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openMapsModal(id, alamat) {
      this.geocoder.geocode({ address: alamat }, (results, status) => {
        this.citizen_lat = results[0].geometry.location.lat();
        this.citizen_long = results[0].geometry.location.lng();
      });
      this.$bvModal.show("modal-maps" + id);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    checkInput() {
      this.submitted = true;
      this.$v.$touch();
      if (
        (this.form.nama == "" &&
          this.form.nik == "" &&
          this.form.nkk == "" &&
          this.form.alamat == "" &&
          this.form.tanggal_lahir == "" &&
          this.form.tempat_lahir == "" &&
          this.form.year_start == "" &&
          this.form.year_end == "") ||
        this.$v.$invalid
      ) {
        console.log("NOT VALIDD ");
        this.valid = false;
      } else {
        this.valid = true;
      }
    },
    searchData() {
      this.error = "";
      this.search = true;
      let query;
      let data = {
        size: this.search_value,
        query: {
          bool: {
            filter: [
              {
                bool: {
                  filter: [],
                },
              },
            ],
          },
        },
      };
      if (data.query.bool.filter[0].bool.filter.length != 0) {
        data.query.bool.filter[0].bool.filter.push([]);
      }

      if (this.form.nama != "") {
        const key = this.form.nama.split(" ");
        for (let i = 0; i < key.length; i++) {
          query = {
            bool: {
              should: [{ match_phrase: { nama: key[i] } }],
              minimum_should_match: 1,
            },
          };
          data.query.bool.filter[0].bool.filter.push(query);
        }
      }

      if (this.form.nik != "") {
        query = {
          bool: {
            should: [{ match_phrase: { nik: this.form.nik } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      if (this.form.nkk != "") {
        query = {
          bool: {
            should: [{ match_phrase: { nkk: this.form.nkk } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      if (this.form.alamat != "") {
        query = {
          bool: {
            should: [{ match_phrase: { alamat: this.form.alamat } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      if (this.form.tanggal_lahir != "") {
        query = {
          bool: {
            should: [
              {
                range: {
                  tanggal_lahir: {
                    gte: this.formatDate(this.form.tanggal_lahir),
                    lte: this.formatDate(this.form.tanggal_lahir),
                    time_zone: "Asia/Jakarta",
                  },
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      if (this.form.tempat_lahir != "") {
        query = {
          bool: {
            should: [
              { match_phrase: { tempat_lahir: this.form.tempat_lahir } },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      if (this.form.year_start != "") {
        query = {
          bool: {
            should: [
              {
                range: {
                  tanggal_lahir: {
                    gte: this.form.year_start,
                    time_zone: "Asia/Jakarta",
                  },
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      if (this.form.year_end != "") {
        query = {
          bool: {
            should: [
              {
                range: {
                  tanggal_lahir: {
                    lte: this.form.year_end,
                    time_zone: "Asia/Jakarta",
                  },
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      this.checkInput();
      if (this.valid) {
        this.loading = true;
        this.resetTable();
        CitizenService.search(this.elastic, data)
          .then((response) => {
            this.resetTable();
            response.data.hits.hits.forEach((val, idx) => {
              const year = moment(
                val._source.tanggal_lahir,
                "YYYY/MM/DD"
              ).format("YYYY");
              const shio = this.shioYear.find((element) =>
                element.year.includes(year)
              );
              const data = {
                no: idx + 1,
                _id: val._id,
                nama: val._source.nama,
                nik: val._source.nik,
                nik_secret: val._source.nik.slice(0, 10) + "******",
                nkk: val._source.nkk,
                nkk_secret: val._source.nkk.slice(0, 10) + "******",
                tempat_lahir: val._source.tempat_lahir,
                tanggal_lahir: val._source.tanggal_lahir,
                alamat: val._source.alamat,
                zodiac: Horoscope.getZodiac(val._source.tanggal_lahir),
                shio: shio.name ?? "unknown",
              };
              this.tableData.push(data);
            });
          })
          .catch((err) => {
            console.log("error->", err);
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            } else if (err.response.status == 403) {
              this.error = "Forbidden";
            }
          })
          .finally(() => {
            this.loading = false;
            this.secret.item.value = [];
          });
      }
    },

    resetTable() {
      this.tableData = [];
    },

    typeForm(e) {
      this.typesubmit = true;
      this.$v.$touch();
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
  },
  created() {
    this.onSendBackProps();
  },
  mounted() {
    this.getPreferences();
    this.$gmapApiPromiseLazy().then(() => {
      if (this.google) {
        this.geocoder = new this.google.maps.Geocoder();
      }
    });
    this.totalRows = this.items.length;
    this.search_value = 100;
  },
};
</script>